import { useEffect, useState } from "react";

function LicenseRightsRows({ data, handleEdit, allTick, onChange, selectAll }) {
  const [isChecked, setIsChecked] = useState(data.Page_Access);

  useEffect(() => {
    setIsChecked(selectAll || data.Page_Access);
  }, [selectAll, data]);

  const handleCheckboxChange = () => {
    console.log(data)
    const newCheckedStatus = !isChecked;

    setIsChecked(newCheckedStatus);
    onChange(data._id, data.Price, newCheckedStatus);
  };

  return (
    <tr className="table-row">
      <td className="table-data">
        <p>{data.Page_Name}</p>
      </td>
      <td className="table-data">
        <p>{data.Module_Name}</p>
      </td>
      <td className="table-data">
        <p>{data.Price}</p>
      </td>
      <td className="table-data">
        <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} />
      </td>
      <td></td>
    </tr>
  );
}

export default LicenseRightsRows;
